export const currentStep = (queryStep?: number | string, maximum?: number) => {
  const current = !isNaN(Number(queryStep)) ? Number(queryStep) : 1;
  if (current > (maximum || Number.POSITIVE_INFINITY) || current < 1) return 1;
  return current;
};
